// components/FeedbackDropdown.js
import React from "react";

export default function FeedbackDropdown({ options, onSelect }) {
  return (
    <div className="feedback-dropdown">
      <ul>
        {options.length > 0 ? (
          options.map((opt, idx) => (
            <li key={idx} onClick={() => onSelect(opt.reason_text)}>
              {opt.reason_text}
            </li>
          ))
        ) : (
          <li>No options available</li>
        )}
      </ul>
    </div>
  );
}
